import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=3bed7c01&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=ts&"
export * from "./TemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=3bed7c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed7c01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VIcon,VImg,VRow})
